import React from 'react';

import TaxExemptWidget from "../below/TaxExemptWidget";
import ChannelPicker from "./ChannelPicker";
import AgentShippingWidget from "../below/AgentShippingWidget";
import PayLaterWidget from "../below/PayLaterWidget";
import PONumberWidget from "../below/PONumberWidget";

/**
 * To add an agent-editable field:
 *
 * - make a widget for it
 * - add field to shopping_cart (attr_property generally)
 * - add to update_cart interactor
 * - added to ShoppingCartSerializer (or pull from .properties)
 *
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */

export default function AgentBelowCartToolbar({...props}) {
  const {currentAgent, shoppingCart, callbacks} = props;

  if (!currentAgent || !currentAgent.id)
    return null;

  return (
    <div className="relative border-2 border-red-900">
      <div className="absolute -left-8 top-0">
        <div className="fa fa-user-secret"></div>
      </div>

      <div className="bg-agent-purple">
        <div className="grid grid-cols-3">
          <div><ChannelPicker {...props} /></div>
          <div>
            <TaxExemptWidget {...props} />
            <PayLaterWidget
              shoppingCart={shoppingCart}
              currentAgent={currentAgent}
              callbacks={callbacks}
            />
          </div>
          <div>
            <PONumberWidget
              shoppingCart={shoppingCart}
              currentAgent={currentAgent}
              callbacks={callbacks}
            />
            <AgentShippingWidget
              shoppingCart={shoppingCart}
              currentAgent={currentAgent}
              callbacks={callbacks}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

//
